import type { ReactNode } from 'react'

export function Container({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <div className={`w-[92%] sm:w-[88%] md:w-[85%] lg:w-[80%] max-w-[1200px] mx-auto relative px-1 sm:px-0 ${className}`}>
      {children}
    </div>
  )
}
